module.exports = __webpack_public_path__ + "./rules/SportsRulesENG.93e15a95158d6988b82b28b4e17dbbc3.pdf";